import { render, staticRenderFns } from "./btn-light-active.mpx?vue&type=template&id=37251e2c&isComponent&outputPath=components%2Fbtn-light-activeab90a1d4%2Findex"
import script from "./btn-light-active.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-light-activeab90a1d4%2Findex"
export * from "./btn-light-active.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-light-activeab90a1d4%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports